import type { PlanTiers } from "@/react/helpers/planHelpers";
import type { Plan } from "@/react/types/Plan";

export const CANCEL_SCHEDULED_DOWNGRADE_SOURCES = {
  SCHEDULED_DOWNGRADE_BANNER: "downgrade_scheduled_banner",
  PLAN_DETAILS: "plan_details",
  FALLBACK_SOURCE: "fallback_source",
} as const;

export type CancelScheduledDowngradeModalSource =
  (typeof CANCEL_SCHEDULED_DOWNGRADE_SOURCES)[keyof typeof CANCEL_SCHEDULED_DOWNGRADE_SOURCES];

export interface Proration {
  applied_balance?: number;
  prorated_charges_credit?: {
    description: string[];
    amount: number;
  };
  prorated_charges_debit?: {
    description: string[];
    amount: number;
  };
  recurring_plan_charges: {
    description: string[];
    amount: number;
  };
  subtotal: number;
  tax?: number;
  total_due_today: number;
}

export interface CanDowngradeResponse {
  blocking_features: string[];
  can_downgrade: boolean;
}

export interface PlanCoupon {
  code: string;
  description: string;
  discount_amount?: string;
  discount_percent?: string;
  id: number;
  name: string;
}

export interface EmailHubPlan {
  amount_without_currency: string;
  contact_count: number;
  current_tier_up_to: number;
  display_interval: string;
  display_name: string;
  interval_abbreviation: string;
  is_free_tier: boolean;
  main_features: string[];
}

export interface UpgradePlanOverrides {
  amount_with_currency?: string;
  amount_without_currency: string;
  annual_discount_amount_with_currency: string | null;
  display_interval: string;
  features_lost_from_current_plan: string[] | null;
  id: number;
  interval_abbreviation: string;
  main_features: string[];
  main_features_summarized: string;
  monthly_base_amount_with_interval: string;
  plan_coupon: PlanCoupon | null;
  tier: PlanTiers;
}

export type UpgradePlan = Partial<Omit<Plan, keyof UpgradePlanOverrides>> &
  UpgradePlanOverrides;
